export const PORTAL_HP_URL = '/portal';
export const PORTAL_SITE_NAME = 'portal';
export const SERVICE = '/service';
export const STIFTUNG_HOHENROTH_HP = 'stiftung-hohenroth';
export const GO_LINK = 'go';
export const ERROR_429_URL = '/error-429';
export const MEDIA_PATH = '/media';
// NOTE: Do never use these URLs without the use of pageContext.rootUrl!
const routes = {
    SEARCH_RESULTS: '/suchergebnisse',
    PUBLICATIONS: {
        CART: '/paedagogik/warenkorb',
        SEARCH_RESULTS: '/paedagogik/publikationen'
    },
    ABOUT: {
        PRIVACY: '/ueber-uns/transparenz/datenschutz'
    },
    DONATION_FORM: '/spenden/online-spenden',
    DONATION_PAGE: '/spenden',
}
export const SERVICES = {
    FORM_SUBMT: SERVICE + '/formsubmit',
    IBAN: SERVICE + '/ibanBic',
    DONATION: SERVICE + '/donationform',
    SAFERPAY: SERVICE + '/saferpay',
    PAYPAL: SERVICE + '/paypal',
    SAFERPAY_COMPLETE: SERVICE + '/saferpayComplete',
    PAYPAL_COMPLETE: SERVICE + '/paypalComplete',
    ORDER: SERVICE + '/orderform',
    DOWNLOAD: SERVICE + '/download',
    LOBSTER_REQUEST: SERVICE + '/lobsterRequest',
    AMOUNT_INCREASE: SERVICE + '/amountIncreaseForm',
    CDN_BLOB: SERVICE + '/cdnBlob',
}

export default routes;